var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 12.0568C4.75 8.01478 7.99937 4.75 12 4.75C16.0006 4.75 19.25 8.01478 19.25 12.0568C19.25 12.471 19.5858 12.8068 20 12.8068C20.4142 12.8068 20.75 12.471 20.75 12.0568C20.75 7.19637 16.839 3.25 12 3.25C7.16095 3.25 3.25 7.19637 3.25 12.0568C3.25 16.8631 7.07434 20.7756 11.8387 20.8621L11.1129 21.3957C10.7791 21.6411 10.7075 22.1105 10.9528 22.4442C11.1982 22.778 11.6676 22.8496 12.0013 22.6043L15.1109 20.3183C15.3031 20.1769 15.4167 19.9526 15.4167 19.714C15.4167 19.4754 15.3031 19.251 15.1109 19.1097L12.0013 16.8237C11.6676 16.5784 11.1982 16.65 10.9528 16.9837C10.7075 17.3175 10.7791 17.7869 11.1129 18.0323L12.8625 19.3185C12.5838 19.3478 12.2964 19.3636 12 19.3636C7.99937 19.3636 4.75 16.0988 4.75 12.0568Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V12C11.25 12.1989 11.329 12.3897 11.4697 12.5303L13.4697 14.5303C13.7626 14.8232 14.2374 14.8232 14.5303 14.5303C14.8232 14.2374 14.8232 13.7626 14.5303 13.4697L12.75 11.6893V8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.988c371dc8847fc43bfc863c91ab407f.svg";
export { ForwardRef as ReactComponent };